import { StylesConfig } from 'react-select';
import { Option } from 'types';

export const customStyles: Partial<StylesConfig<Option, false>> = {
  container: (base, { isFocused }) => ({
    ...base,
    borderRadius: '12px',
    backgroundColor: 'var(--color5)',
    width: '100%',
    border: `1px solid ${isFocused ? 'var(--color2)' : 'var(--color10)'}`,
    boxShadow: isFocused ? '0 0 0 3px rgba(206, 17, 38, 0.08)' : 'none',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: isFocused ? 'var(--color2)' : 'var(--color9)',
    },
  }),
  control: base => ({
    ...base,
    maxHeight: `64px`,
    minHeight: `62px`,
    boxShadow: 'none',
    border: 'none',
    background: 'transparent',
    padding: '0 16px',
    cursor: 'pointer',
  }),
  placeholder: base => ({
    ...base,
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    fontFamily: "'Poppins', 'Arial', sans-serif",
    color: 'var(--color9)',
  }),
  valueContainer: base => ({
    ...base,
    display: 'flex',
    maxWidth: '100%',
    padding: 0,
    overflow: 'auto',
    ['::-webkit-scrollbar']: {
      display: 'none',
    },
  }),
  singleValue: base => ({
    ...base,
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    fontFamily: "'Poppins', 'Arial', sans-serif",
    color: 'var(--color6)',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base, { isFocused }) => ({
    ...base,
    color: isFocused ? 'var(--color2)' : 'var(--color9)',
    transition: 'color 0.2s ease, transform 0.2s ease',
    padding: '0 2px',
    '&:hover': {
      color: 'var(--color6)',
    },
    ...(isFocused ? { transform: 'rotate(180deg)' } : {}),
  }),
  indicatorsContainer: base => ({
    ...base,
    height: '24px',
    padding: `0 2px`,
  }),
  menu: base => ({
    ...base,
    top: `calc(100% + 6px)`,
    margin: 0,
    zIndex: 1000,
    padding: 0,
    borderRadius: `12px`,
    border: '1px solid var(--color10)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    animation: 'selectMenuFadeIn 0.15s ease-out',
  }),
  menuList: base => ({
    ...base,
    padding: `6px 0`,
    maxHeight: `240px`,
  }),
  option: (base, { isSelected, isFocused }) => ({
    ...base,
    padding: `10px 16px`,
    minHeight: `40px`,
    fontWeight: isSelected ? '500' : 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    fontFamily: "'Poppins', 'Arial', sans-serif",
    color: 'var(--color6)',
    background: isSelected ? 'var(--color8)' : isFocused ? 'rgba(253, 240, 224, 0.5)' : 'var(--color5)',
    transition: 'background 0.15s ease',
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderRadius: '4px',
    margin: '0 4px',
    width: 'calc(100% - 8px)',

    '&:active': {
      background: 'var(--color8)',
    },
  }),
  noOptionsMessage: base => ({
    ...base,
    fontFamily: "'Poppins', 'Arial', sans-serif",
    fontSize: '14px',
    color: 'var(--color9)',
  }),
};
